import { api, ApiError } from "./api";
import type { RoomView } from "@digu/shared";

/** The server refuses a second seat with code "busy" ("Leave your current table before…"). */
export const isTableConflict = (e: unknown): boolean => e instanceof ApiError && e.status === 409 && e.code === "busy";

/** The table the player is still seated at, if any (server truth, not the cached session). */
export async function currentTable(): Promise<string | null> {
  const home = await api.get<{ currentRoom: string | null }>("/home");
  return home.currentRoom;
}

/** Leaves a table: fetch the live version first, since every action carries one. Returns false if the seat was already gone. */
export async function leaveTable(code: string): Promise<boolean> {
  let view: RoomView;
  try { view = await api.get<RoomView>(`/rooms/${encodeURIComponent(code)}`); }
  catch (e) { if (e instanceof ApiError && e.status === 404) return false; throw e; }
  if (view.archived || view.players[view.self]?.left) return false;
  await api.post(`/rooms/${encodeURIComponent(code)}/act`, { type: "leave", version: view.version });
  return true;
}
